import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import { Link } from 'react-router-dom'
import { useThemeMode } from '../../../../../_metronic/partials'
import { getSourceReferenceData } from '../../core/_requests'
import { useAuth } from '../../../auth'
import Skeleton from 'react-loading-skeleton'

const AvailableStorage = () => {
  const { formatMessage } = useIntl()
  const [storageSize, setStorageSize] = useState<any>()
  const { mode } = useThemeMode()

  const [isLoading, setIsLoading] = useState(false)
  const { companyId } = useAuth()

  async function fetchStorageSize() {
    setIsLoading(true)
    try {
      const {
        data: { success, data, errors },
      } = await getSourceReferenceData('recordKeeperStorageSize', companyId!)
      if (success) {
        setStorageSize(data)
      } else {
        console.error(errors)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchStorageSize()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div
      className='p-6 d-flex flex-column justify-content-center align-items-center rounded'
      style={
        mode === 'dark' ? { background: '#323248', height: '280px', width: '100%' } : { background: '#ffffff', height: '280px', width: '100%' }
      }
    >
      {isLoading ? (
        <div>
          <Skeleton
            height={145}
            width={160}
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
          />
        </div>
      ) : (
        <CircularProgressbar
          className='w-100 mb-2'
          value={storageSize && storageSize.percentageUsed ? parseInt(storageSize.percentageUsed) : 0}
          text={`${parseInt(storageSize?.percentageUsed) ?? 0}%`}
          strokeWidth={18}
          styles={buildStyles({
            strokeLinecap: 'round',
            textSize: '16px',
            pathTransitionDuration: 0.5,
            pathColor: storageSize && storageSize?.percentageUsed >= 90 ? 'red' : '#4776E6',
            textColor: mode === 'dark' ? 'White' : 'Black',
            trailColor: mode === 'dark' ? '#4A6FA6' : '#D6ECFD',
          })}
        />
      )}

      {isLoading ? (
        <div>
          <Skeleton
            height={25}
            width={80}
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
            className='mb-2'
          />
        </div>
      ) : (
        <h1 className='font-size-14 my-4'>{`${storageSize && storageSize.storageSize ? storageSize.storageSize : 0
          } / ${storageSize && storageSize.sizeFromChargebeeWithUnit ? storageSize.sizeFromChargebeeWithUnit : '0 GB'
          }`}</h1>
      )}

      <p className='text-muted font-size-12 lh-base'>{formatMessage({ id: 'Available Storage' })}</p>
      {storageSize && storageSize.percentageUsed >= 90 && (
        <Link to='' className='text-primary font-size-13 fw-semibold mt-2'>
          {formatMessage({ id: 'Manage Storage' })}
        </Link>
      )}
      <Link
        to='/setting/billing-invoice?tab=storage-and-ai-usage'
        className='text-primary font-size-13 fw-semibold mt'
      >
        {formatMessage({ id: 'Upgrade Now' })}
      </Link>
    </div>
  )
}

export default AvailableStorage
